// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ka-0";
export var animationContainer = "_ka-1";
export var itemPrice = "_ka-a";
export var itemizedContent = "_ka-9";
export var itemizedHeader = "_ka-7";
export var itemizedRow = "_ka-8";
export var itemizedSection = "_ka-6";
export var modalContent = "_ka-2";
export var orderName = "_ka-3";
export var refundOption = "_ka-4";
export var refundOptionsContainer = "_ka-5";
export var shippingLabel = "_ka-b";
export var totalRow = "_ka-c";